module.exports = __webpack_public_path__ + "static/media/bpjs64.f9f00a8f.png";